module.exports = __webpack_public_path__ + "img/bg-master.ed73f6b9.png";